import React, { useState } from 'react';
import '../../components/app/common.scss';
import toList from './ComponentUtil';


function CustomRadioInput({ options = [], multiple = false, value = [], onChange = undefined, label = undefined, parent = undefined, prop = undefined}) {
    const [selection, setSelection] = useState(value);
    const unselect = (i) => {
        selection.splice(i, 1);
        setSelection([...selection]);
    }
    
    const handleInputChange = (e, i, onChange) => {
        e.preventDefault();
        let s = [];
        if(selection.includes(options[i])){
            unselect(selection.indexOf(options[i]));
        }
        else {
            if(multiple) {
                s = [...selection, options[i]];
            }
            else {
                s = [options[i]];
            }
            setSelection(s);
        }
        if (parent) {
            parent[prop] = s;
        }
        onChange && onChange(e, s);
    }

    return (
        <div className='custom-radio-component'>
            {label && <label>{label}</label>}
            <div className='options'>
                {toList(options, undefined, (item, i) => 
                    <div className={'option' + (selection.includes(item) ? ' selected' : '')}  key={i} onClick={(e) => handleInputChange(e, i, onChange)}>{item}</div>
                )}
            </div>
        </div>
    );
}

export default CustomRadioInput;